import React, { useEffect } from 'react';
import { useProfile } from 'src/utils/ProfileService';
import { useTheme } from './ThemeProvider';

/**
 * Applies the backend-stored theme preference app-wide. Kept separate from
 * ThemeProvider so the provider stays usable (e.g. in Storybook or tests)
 * without a ProfileProvider ancestor. Render inside both ThemeProvider and
 * ProfileProvider.
 */
export const ThemeSync: React.FC = () => {
  const { profile } = useProfile();
  const { setTheme } = useTheme();

  useEffect(() => {
    if (typeof profile?.is_in_dark_mode === 'boolean') {
      setTheme(profile.is_in_dark_mode ? 'dark' : 'light');
    }
  }, [profile?.is_in_dark_mode]);

  return null;
};
